import { initRedirectToCheckout } from '../../../../../Common/Resources/src_front/js/components/initRedirectToCheckout';
import { trackMixpanelBeforeRedirectToCheckout } from '../helper-function/trackMixpanelBeforeRedirectToCheckout';

initRedirectToCheckout(trackMixpanelBeforeRedirectToCheckout);
